// DonatePopup.js
import React, { useState } from "react";

export default function DonatePopup({ show, onClose }) {
  const [showDonation, setShowDonation] = useState(false);
  const [customAmount, setCustomAmount] = useState("");
  const donationAmounts = [5, 10, 20, 50, 100];

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-sm shadow-lg text-center">
        <h3 className="text-lg font-semibold mb-4 text-[#5e4b8b]"></h3>
        <p className="mb-4 text-base text-[#021868]">
          If this space has brought you clarity, comfort, or even a moment of peace,
          consider leaving a small offering to help keep the light on for others who may wander in.
        </p>
        <div className="mt-4 flex flex-col items-center">
          <button
            onClick={() => setShowDonation(!showDonation)}
            className="bg-[#014C75]/80 text-white border border-[#021868] shadow-xl px-5 py-2 rounded-full shadow-xl hover:text-white hover:bg-[#021868] transition"
          >
            💖 Donate via PayPal
          </button>

          {showDonation && (
            <div className="mt-4 w-full flex flex-col items-center space-y-3">
              <div className="flex flex-wrap justify-center gap-3">
                {donationAmounts.map((amount) => (
                  <a
                    key={amount}
                    href={`https://www.paypal.me/tarotfatecom/${amount}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-[white] border border-[#021868] text-[#021868] px-4 py-2 rounded-xl text-sm hover:text-white hover:bg-[#021868] transition"
                  >
                    ${amount}
                  </a>
                ))}
              </div>

              <div className="text-center mt-3">
                <p className="text-xs text-[#021868] mb-1">Or enter your own amount (max $1,000)</p>
                <input
                  type="text"
                  inputMode="decimal"
                  value={customAmount}
                  onChange={(e) => {
                    const value = e.target.value.trim();
                    const isValid = /^(\d+(\.\d{0,2})?)?$/.test(value);
                    if (isValid && parseFloat(value || "0") <= 1000) {
                      setCustomAmount(value);
                    }
                  }}
                  className="border border-[#021868] rounded px-3 py-1 w-32 text-center text-[#021868]"
                  placeholder="Other ($)"
                />
                {customAmount && parseFloat(customAmount) > 0 && (
                  <div className="mt-2">
                    <a
                      href={`https://www.paypal.me/tarotfatecom/${customAmount}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block bg-white border border-[#021868] text-[#021868] px-4 py-1.5 rounded-full shadow hover:text-white hover:bg-[#021868] transition text-sm"
                    >
                      Donate ${customAmount}
                    </a>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        <button
          onClick={onClose}
          className="mt-4 text-sm text-gray-500 hover:underline block mx-auto"
        >
          Close
        </button>
      </div>
    </div>
  );
}
